import { useProNavigate } from '@mp/contexts';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import React from 'react';
import { OrientationJobsListItemGql } from './graphql';
import { Box, HStack, Label, Text, VStack, isMobile } from '@medely/ui-kit';
import JobDisplayHelpers from '@mp/components/jobs/jobDisplayHelpers';
import { centsToCurrency, currencyWithoutDecimalFormat } from '@mp/utils';

interface OrientationJobsListItemProps {
  job: FragmentType<typeof OrientationJobsListItemGql>;
}

export const OrientationJobsListItem = ({ job: passedJob }: OrientationJobsListItemProps) => {
  const mobile = isMobile();
  const job = parseFragmentData(OrientationJobsListItemGql, passedJob);
  const { navigate } = useProNavigate();

  const handleClick = () => {
    navigate('AvailableJobDetails', { id: job.id });
  };

  const jobAddressCity = job.location?.address_city || '';
  const jobAddressZip = job.location?.address_zip || '';
  const jobCityStateZip = [jobAddressCity, jobAddressZip].join(' ');

  return (
    <Box onClick={handleClick}>
      <HStack justifyContent="space-between" alignItems="center">
        <VStack>
          <Box mb={0.5}>
            <Label size="m">{JobDisplayHelpers.positions(job)} Float Pool Orientation</Label>
          </Box>
          <Text size="m">{jobCityStateZip}</Text>
          <Text size="m">{JobDisplayHelpers.formatSpecialties(job, mobile, 35)}</Text>
          <Text size="m">{JobDisplayHelpers.fullDayDate(job)}</Text>
          <Text size="m">{JobDisplayHelpers.time(job)}</Text>
        </VStack>
        <VStack>
          <Box>
            {job.job_billing_sums?.payout_total_amount_cents && (
              <Label size="l" color="state.success.secondary">
                {centsToCurrency(
                  job.job_billing_sums?.payout_total_amount_cents,
                  currencyWithoutDecimalFormat,
                  true,
                )}
              </Label>
            )}
          </Box>
        </VStack>
      </HStack>
    </Box>
  );
};
